module.exports = __webpack_public_path__ + "static/media/image18.28728d44.png";